import { Box, Stack, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { uniTypography } from '@src/fonts/typography/uniTypography';

export const AuthCardRoot = styled(Stack)(() => ({
  gap: uni('scale-600'),
  width: '100%',
}));

export const AuthCardTextGroup = styled(Stack)(() => ({
  gap: uni('scale-100'),
  width: '100%',
}));

export const AuthCardTitle = styled('p')`
  ${uniTypography('text-lg', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
  margin: 0;
`;

export const AuthCardSubtitle = styled('p')`
  ${uniTypography('text-md', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
`;

export const AuthCardButtonWrapper = styled(Box)(() => ({
  width: '100%',
}));
